/** آدرس پایهٔ سایت عمومی (فرانت دوره‌ها) برای پیش‌نمایش از پنل ادمین */

const normalizeUrl = (url: string) => url.replace(/\/$/, '');

const isLocalHost = (hostname: string) =>
  hostname === 'localhost' || hostname === '127.0.0.1';

const isPrivateLanHost = (host: string) =>
  /^192\.168\.\d{1,3}\.\d{1,3}$/.test(host) ||
  /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host) ||
  /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(host);

/** پورت پیش‌فرض فرانت در dev: Nest معمولاً ۳۰۰۰، پنل ادمین ۳۰۰۱؛ CRA اولین پورت آزاد را می‌گیرد که اغلب ۳۰۰۲ است — نباید با API اشتباه گرفته شود. */
const defaultLocalFrontendPort =
  process.env.REACT_APP_PUBLIC_SITE_PORT?.trim()?.replace(/^:/, '') || '3002';

/**
 * در ترتیب اولویت:
 * ۱) `REACT_APP_PUBLIC_SITE_URL` — کل آدرس سایت عمومی، مثل `http://localhost:3002` یا `https://manehaghighi.com`
 * ۲) لوکال/LAN بدون آن: hostname + پورت از `REACT_APP_PUBLIC_SITE_PORT` یا پیش‌فرض **`3002`**
 *
 * ⚠️ اگر لینک «نمایش در سایت» به جای SPA به Nest برود (خطای JSON 404 برای مسیر `/courses/...`)
 * یعنی پورت یا DOMAIN اشتباه است؛ آن را با `REACT_APP_PUBLIC_SITE_URL` در `.env` ادمین تنظیم کنید.
 */
export function getPublicSiteBaseUrl(): string {
  const envFull = process.env.REACT_APP_PUBLIC_SITE_URL?.trim();
  if (envFull) return normalizeUrl(envFull);

  if (typeof window === 'undefined') {
    return `http://localhost:${defaultLocalFrontendPort}`;
  }

  const { hostname, protocol } = window.location;

  if (isLocalHost(hostname) || isPrivateLanHost(hostname)) {
    const h = isLocalHost(hostname) ? '127.0.0.1' : hostname;
    return `${protocol}//${h}:${defaultLocalFrontendPort}`;
  }

  return window.location.origin;
}

export function getPublicCourseDetailUrl(course: { slug?: string | null; id: string } | string): string {
  const segment =
    typeof course === 'string'
      ? course
      : (course.slug != null && String(course.slug).trim()) ? String(course.slug).trim() : course.id;
  return `${getPublicSiteBaseUrl()}/courses/${encodeURIComponent(segment)}`;
}

/** پیش‌نمایش دسته در سایت عمومی؛ پادکست فعلاً `?cat=` ممکن است در UI فیلتر نشود ولی برای آینده حفظ می‌شود. */
export function getPublicCategoryBrowseUrl(type: 'COURSE' | 'PODCAST', slug: string): string {
  const base = getPublicSiteBaseUrl();
  const safe = encodeURIComponent(String(slug).trim());
  if (type === 'COURSE') {
    return `${base}/courses/browse?cat=${safe}`;
  }
  return `${base}/podcasts?cat=${safe}`;
}
